import { render, staticRenderFns } from "../ItemSelectModal.html?vue&type=template&id=7c49f6ff&scoped=true&external"
import script from "./MaterialSelectModal.ts?vue&type=script&lang=ts&external"
export * from "./MaterialSelectModal.ts?vue&type=script&lang=ts&external"
import style0 from "./MaterialSelectModal.scss?vue&type=style&index=0&id=7c49f6ff&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c49f6ff",
  null
  
)

export default component.exports